// extracted by mini-css-extract-plugin
module.exports = {"error":"ConfirmAlertBox_error__394eG","dialogActions":"ConfirmAlertBox_dialogActions__1kv7j"};